module.exports = __webpack_public_path__ + "static/media/youtube-comparativo.2d0dc36d.png";